/**
 * CanvasRegressionBandRow — `canvas.regression-band` renderer.
 * Fills the confidence band around the kernel-smoothed regression
 * curve for a `(number, series)` source.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/**
 * The `canvas.regression-band` painter row: fills the confidence band around a series' smoothed
 * regression curve.
 */
export class CanvasRegressionBandRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  get fill(): Option<string> {
    return Json.string(this.attrs(), "fill");
  }

  /** 0..1 alpha for the band fill (defaults to 0.2). */
  get opacity(): number {
    return Json.number(this.attrs(), "opacity") ?? 0.2;
  }
}
